import customization from './modules/customization/store.js'

export default { customization }